
import {
  SET_THEME,
  SET_SIDEBAR_COLLAPSED,
  SET_RECENT_INCIDENTS_HISTORY,
  LOGOUT_MODAL_TOGGLE,
  DASHBOARD_NAME,
  SET_MEET_MODE,
  SET_INCIDENTS_DATAS,
  DASHBOARD_INCIDENT_MODAL_TOGGLE,
  SET_INCIDENT_MODAL_STATE,
} from '../ActionType/actionType';
 
 
// Initial State
const organizationInitialState = {
  theme: localStorage.getItem('theme') || 'light',
  isDashboardIncidentModaltoggle: false,
  incidentModalState: 'closed',
  isSidebarVisible: true,
  isSidebarCollapsed: false, // default: expanded (not collapsed)
  recentIncident:{},
  isLogoutModalOpen: false,
  dashboardName : localStorage.getItem('dashboardTitle') || "Dashboard",
  meetMode: 'voice',
  incidents : []
};
 
export const organizationReducer = (state = organizationInitialState, action) => {
  const {  type, payload } = action;
  switch (type) {
 
    case SET_THEME:
      return {
        ...state,
        theme: payload
      };
 
    case DASHBOARD_INCIDENT_MODAL_TOGGLE: {
      const nextState = typeof payload === 'boolean'
        ? (payload ? 'open' : 'closed')
        : payload;
      return {
        ...state,
        incidentModalState: nextState,
        isDashboardIncidentModaltoggle: nextState === 'open',
      };
    }

    case SET_INCIDENT_MODAL_STATE:
      return {
        ...state,
        incidentModalState: payload,
        isDashboardIncidentModaltoggle: payload === 'open',
      };
 
    case SET_SIDEBAR_COLLAPSED:
      return {
        ...state,
        isSidebarCollapsed: payload
      };

    case SET_RECENT_INCIDENTS_HISTORY:
      return {
        ...state,
        recentIncident: payload
      }

    case LOGOUT_MODAL_TOGGLE:
      return {
        ...state,
        isLogoutModalOpen: payload
      }
    case DASHBOARD_NAME :
      localStorage.setItem("dashboardTitle", payload)
      return {
        ...state,
        dashboardName : payload
      }
    case SET_MEET_MODE:
      return{
        ...state,
        meetMode :payload
      }
    case SET_INCIDENTS_DATAS:
      return {
        ...state,
        incidents : payload
      }

    default:
      return state;
  }
};